module.exports = __webpack_public_path__ + "static/media/seeker.1ab3998b.png";